import { render, staticRenderFns } from "./insertSupportTicket.vue?vue&type=template&id=78889bb9"
import script from "./insertSupportTicket.vue?vue&type=script&lang=js"
export * from "./insertSupportTicket.vue?vue&type=script&lang=js"
import style0 from "./insertSupportTicket.vue?vue&type=style&index=0&id=78889bb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports